















































import { Component, Vue } from 'vue-property-decorator';
import MatrixLegend from '@/components/Matrix/MatrixLegend.vue';
import env from '@/env';
import axios from 'axios';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import { Step } from '@/interfaces/Step';
import { Environment } from '@/interfaces/Environment';
import WaveMatrixStarttimeInput from '@/components/FormElements/WaveMatrixStarttimeInput.vue';
import SaveButton from '@/components/App/SaveButton.vue';

@Component({
  components: { SaveButton, WaveMatrixStarttimeInput, MatrixLegend }
})
export default class WaveMatrixView extends Vue {
  private matrix: (Cutoverplan & { appointments: Step[] })[] = [];

  private id = 0;

  private blueprintAppointments: Step[] = [];

  async mounted() {
    this.$emit('showPreloader');

    this.id = +this.$route.params.wave_id;
    const alreadyPushed: number[] = [];

    const { data: matrix } = await axios.get(`${env.backend_url}/wave/${this.id}/matrix`);
    this.matrix = matrix;

    const allAppointments = matrix.reduce(
      (accumulator: Step[], cutoverplan: Cutoverplan & { appointments: Step[] }) => {
        accumulator.push(...cutoverplan.appointments);
        return accumulator;
      },
      []
    );
    allAppointments.forEach((appointment: Step) => {
      if (!appointment.blueprint_id || alreadyPushed.includes(appointment.blueprint_id)) return;
      alreadyPushed.push(appointment.blueprint_id);

      this.blueprintAppointments.push(appointment.blueprint);
    });
    this.blueprintAppointments = this.blueprintAppointments.sort(
      (a: Step, b: Step) => (a.position || 0) - (b.position || 0)
    );

    this.$emit('loadingFinished');
  }

  get cutoverplanPerEnvironment() {
    const cutoverplanEnvironments: {
      cutoverplan: Cutoverplan & { appointments: Step[] };
      environment: Environment;
    }[] = [];

    this.matrix.forEach((cutoverplan) => {
      cutoverplanEnvironments.push({
        cutoverplan,
        environment: { id: 0, name: 'DEFAULT' } as Environment
      });
      cutoverplan.environments.forEach((cutoverplanEnvironment) => {
        cutoverplanEnvironments.push({
          cutoverplan,
          environment: cutoverplanEnvironment.environment
        });
      });
    });

    return cutoverplanEnvironments;
  }

  save() {
    return axios.post(`${env.backend_url}/wave/${this.id}/matrix`, this.matrix);
  }

  get headers() {
    return [
      {
        text: 'App',
        align: 'start',
        value: 'name',
        width: '100px',
        class: 'tableFixed tableZ secondary white--text'
      },
      {
        text: 'Env',
        align: 'start',
        value: 'env',
        width: '100px',
        class: 'tableFixed2 tableZ secondary white--text'
      },
      ...this.blueprintAppointments.map((appointment) => ({
        text: '' /* TODO: appointment.name */,
        value: `${appointment.id}`,
        sortable: false,
        class: 'tableHead'
      }))
    ];
  }

  get tableItems() {
    return this.cutoverplanPerEnvironment.map(({ cutoverplan, environment }) => ({
      name: cutoverplan.name,
      env: environment.name,
      category: cutoverplan.name,
      environment,
      cutoverplan
    }));
  }
}
